import { IconButton } from "@material-ui/core";
import { ChevronLeftOutlined, ChevronRightOutlined } from "@mui/icons-material";
 
const CustomScrollButton = (props) => {
  const { direction, onClick, disabled } = props;
 
  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      style={{
        width: 36,
        height: 36,
        visibility: disabled ? "hidden" : "visible",
        color: "white",
        backgroundColor: "#0067A1",
        borderRadius: "100%",
        fontSize: "28px",
      }}
    >
      {direction === "left" ? (
        <ChevronLeftOutlined />
      ) : (
        <ChevronRightOutlined />
      )}
    </IconButton>
  );
};
 
export default CustomScrollButton;
 